import { render, staticRenderFns } from "./ProgramsSingleManagerAssignmentsGraduateListItem.vue?vue&type=template&id=653f6f08&"
import script from "./ProgramsSingleManagerAssignmentsGraduateListItem.vue?vue&type=script&lang=js&"
export * from "./ProgramsSingleManagerAssignmentsGraduateListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports